import { render } from "./HeroiconsSolidCog.vue?vue&type=template&id=d808a8ec"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCog.vue"]])

export default __exports__